<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter-number"><a id="page-31"></a><a href="#/toc#toc-chapter006">5</a></h1>
<h1 class="chapter-title"><a href="#/toc#toc-chapter006"></a></h1>
<p class="noindent"><span class="dropcap">M</span>itch set their backpacks at their customary place by the main exit, where they could be grabbed in a hurry if necessary. Bitsy
         had hired someone to clean the place from top to bottom, so all Mitch and Julia had to do was make themselves at home.
      </p>
<p>The carriage house was a square brick building tethered to the back of the Blunt home by an alley. The carriage that had once
         been lodged there was long gone, and the space had been divided into a series of rooms. He had known far bigger homes with
         many more rooms and many more floors, but Julia walked the space as though she were a farmer tramping a magical pasture somewhere
         over the rainbow. Every nook, every cabinet, every window ledge, was exclaimed upon and marveled over. He indulged her fascination
         and used it to dampen his own uneasiness.
      </p>
<p>That night they had dinner with the Blunts again, and this time, Sara Jean was there. She looked fully recovered from her
         ordeal, if a little withdrawn, especially around her parents.
      </p>
<p><a id="page-32"></a>Mitch volunteered himself and Julia to do the cleanup, and when Bitsy protested, Julia said, “Oh, no. He’s an expert at dishwashing.
         It’s just about the best thing he does.”
      </p>
<p>Mitch could have shaken her, though she was right. But in the midst of this comfortable house, with its professional owner
         and his family, dishwashing seemed shameful.
      </p>
<p>“That’s what you’re looking for?” Tommy asked. “Jobwise, I mean?”</p>
<p>“He fries stuff, too.”</p>
<p>Sara Jean added, “Maybe he can fry something for us.”</p>
<p>Mitch gave Julia a scolding look. “You’ve been talking about me?”</p>
<p>“Well,” she said, though she knew it was against the rules. “You do fry things.”</p>
<p>“I’m a fry cook,” Mitch explained to Tommy, who nodded thoughtfully. “But I can do whatever you got. Janitorial, light carpentry,
         lawn maintenance.”
      </p>
<p>“He makes patty melts,” Julia said. “And egg creams.”</p>
<p>Sara Jean looked horrified. “Yuck.”</p>
<p>Julia giggled.</p>
<p>“Don’t worry,” Mitch said, “there’s no egg and just a little cream in it.”</p>
<p>“But there is chocolate!” Julia cried.</p>
<p>“Then why’s it called an egg cream?” Sara Jean asked.</p>
<p>Mitch winked. “A mystery for the ages.”</p>
<p>The doorbell rang, and Bitsy disappeared to answer it. She came back with a short, stocky bulldog of a woman carrying a nylon
         bag over her shoulder. Bitsy didn’t look <a id="page-33"></a>very happy, but the newcomer greeted Tommy effusively, then asked Sara Jean how she was.
      </p>
<p>“Fine,” Sara Jean murmured.</p>
<p>“And this must be our hero,” the woman said, looking at Mitch.</p>
<p>“This is Mitch Turner,” Tommy said. “And that’s his daughter, Julia. Mitch, this is Shelby Townsend. She owns the <em>Crossroads Sentinel.</em>”
      </p>
<p>Mitch froze. He was allergic to reporters the way some people were allergic to shellfish—even small-town ones were deadly.
         But there he was in the Blunt kitchen in front of the whole family and Julia. He couldn’t exactly take off. So when Shelby
         stuck out a pudgy hand, Mitch took it. Her grip was tight and the handshake firm, an indication of how she handled the world,
         which only increased his apprehension.
      </p>
<p>Bitsy said, “Shelby, I’m not sure we want everyone in town knowing—”</p>
<p>But Shelby overrode her concern. “How’s about we get you over here, Mr. Turner.” Before he could protest, she had her camera
         out and was taking his picture. He put up a hand to cover his face and tried ducking his head, but she just kept taking pictures
         until she got one she liked.
      </p>
<p>When she tried to question him about the rescue, he said, “I really don’t want to make a big deal out of it.”</p>
<p>“A modest hero, too.” Shelby beamed.</p>
<p>“Really,” Mitch protested. “I’m not a—”</p>
<p>“You’re a hero to Sara Jean,” Julia said.</p>
<p>“Butt out, Junebug.”</p>
<p>“I’m just saying—”</p>
<p>“How about you, Sara Jean?” Shelby asked. “No more playing near the river?”</p>
<p><a id="page-34"></a>Sara Jean flashed a quick look at Mitch and her parents, then answered Shelby with downcast eyes. “No, ma’am,” she said.
      </p>
<p>“Bet you were scared,” Shelby said, fishing.</p>
<p>The normal answer would have been yes. The more likely answer, given the situation at the time, was no. Sara Jean seemed caught
         between the two, so Mitch threw an arm around her, shielding her from the nosy reporter. “Of course she was. And now I think
         it’s time for Sara Jean to get those… uh… those pajamas for Julia.”
      </p>
<p>Sara Jean looked at him blankly. “Pajamas?”</p>
<p>Thank God for Julia. “You remember,” she broke in quickly. “The <em>pajamas</em> you were going to lend me.” She grabbed Sara Jean’s hand and dragged her away.
      </p>
<p>Bitsy bit her lip. “How did you hear about the… uh, accident?” she asked Shelby.</p>
<p>Shelby winked. “Can’t reveal my sources, now, can I?”</p>
<p>Bitsy frowned and threw Tommy a baleful look. “That Emmalyn Mosley has a big mouth.”</p>
<p>Tommy’s face reddened. “My secretary did not…”</p>
<p>Shelby found something interesting in her camera bag to look at, and the rest of Tommy’s words died out. Struggling for what
         to do or say, he blurted out, “Shelby, join us for banana pudding?”
      </p>
<p>Bitsy looked like she wanted to clap her husband over the head with a frying pan, but she quickly recovered. “Of course, we’d
         love to have you. Mitch, would you call the girls down for me?”
      </p>
<p>But he didn’t want either Julia or Sara Jean around while the reporter was still there. “How about we let them have some girl
         time. They can have dessert later.”
      </p>
<p><a id="page-35"></a>“Later?” Shelby asked. “Are you staying with the Blunts, Mr. Turner?”
      </p>
<p>“Mitch and Julia are in the carriage house,” Tommy said as Bitsy began serving out the custard.</p>
<p>“Nice of you.” But she looked at Mitch thoughtfully, as though wondering if Sara Jean’s rescue had been a clever way to insinuate
         himself on the Blunts and the town.
      </p>
<p>“He’s looking for work, too,” Tommy added. “Maybe you know something?” Without prompting, Tommy ran down the list of things
         Mitch had said he’d done.
      </p>
<p>Mitch tensed. The Blunts meant well, but he felt spread-eagled and staked to the ground.</p>
<p>Thankfully, Shelby shook her head. “Can’t think of anything at the moment.” She dug into dessert. “Don’t suppose you know
         much about computers?”
      </p>
<p>“Sorry,” Mitch said, not sorry at all. “Bit of a Luddite.”</p>
<p>Shelby looked as if she never expected him to know, let alone use, that word.</p>
<p>“That’s okay,” Bitsy said. “I’m sure something will turn up.”</p>
<p>That’s what Mitch was worried about.</p>
<p class="space-break">Mitch’s picture ran in the <em>Crossroads Sentinel</em> along with the story of his rescue of Sara Jean. Both Bitsy and Tommy made sure he had a copy. Julia was thrilled and wouldn’t
         stop talking about it. The chatter was nerve-racking, but it was too late to do anything more than hope the small-town paper
         didn’t have much circulation outside of Crossroads.
      </p>
<p>Two days later, a grizzled guy named Crick, who was eighty if he was a day, stopped by and offered Mitch a job <a id="page-36"></a>at a small restaurant he owned in the dwindling downtown strip. His grill man had gone into rehab and wasn’t expected back
         anytime soon.
      </p>
<p>The hours were good—only breakfast and lunch—so Mitch could pick up Julia from school, and Crick agreed to pay him in cash.
         Mitch told him he wouldn’t be there past Christmas, but the two months would give Crick time to find a more permanent replacement.
      </p>
<p>They shook hands, and Mitch started work the next day.</p>
<p>The following week, the first murder happened.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter006.vue?cf3fad12